var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.277 0.78134C11.5267 0.723961 11.788 0.745739 12.0247 0.843649C12.2614 0.94156 12.4618 1.11074 12.598 1.32771L13.8239 3.28503C13.9228 3.44268 14.056 3.57592 14.2136 3.67477L16.171 4.90071C16.3884 5.03679 16.558 5.23727 16.6561 5.47424C16.7543 5.71122 16.7761 5.9729 16.7186 6.22286L16.2006 8.47248C16.1588 8.65429 16.1588 8.84321 16.2006 9.02502L16.7186 11.2759C16.7756 11.5255 16.7534 11.7866 16.6553 12.0231C16.5572 12.2596 16.3879 12.4596 16.171 12.5956L14.2136 13.8227C14.056 13.9216 13.9228 14.0548 13.8239 14.2125L12.598 16.1698C12.462 16.387 12.2617 16.5564 12.025 16.6546C11.7882 16.7527 11.5268 16.7747 11.277 16.7174L9.02619 16.1994C8.84478 16.1578 8.6563 16.1578 8.47489 16.1994L6.22403 16.7174C5.97425 16.7747 5.71284 16.7527 5.47612 16.6546C5.23939 16.5564 5.03912 16.387 4.90312 16.1698L3.67717 14.2125C3.57797 14.0547 3.4443 13.9214 3.2862 13.8227L1.33012 12.5968C1.11292 12.4608 0.943488 12.2605 0.845351 12.0238C0.747214 11.7871 0.72525 11.5257 0.782511 11.2759L1.29928 9.02502C1.34107 8.84321 1.34107 8.65429 1.29928 8.47248L0.781278 6.22286C0.723857 5.97277 0.745869 5.711 0.844246 5.47401C0.942622 5.23702 1.11247 5.03662 1.33012 4.90071L3.2862 3.67477C3.4443 3.57607 3.57797 3.44282 3.67717 3.28503L4.90312 1.32771C5.03921 1.11098 5.23936 0.94195 5.47582 0.844052C5.71227 0.746155 5.97333 0.724238 6.2228 0.78134L8.47489 1.29811C8.6563 1.33971 8.84478 1.33971 9.02619 1.29811L11.277 0.78134Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68555 9.40953L8.19541 11.8133L11.8153 5.68359",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedCalendar);
export default __webpack_public_path__ + "static/media/verified_calendar.0418a203135ddd0187004c984e5e4048.svg";
export { ForwardRef as ReactComponent };